import * as React from "react";
import autobind from "class-autobind";
import { logger } from "../../../../common/utils/logger/index";
import {SelectAdv} from "../../form/select.adv/index";
import {GoogleFont, GoogleServiceType} from "../../../../client/libs/google";

interface Props {
  value: string;
  onChange: (font: DesignFont) => void;
  google: GoogleServiceType;
}
interface State {
  loading: boolean;
  fonts: GoogleFont[];
}

export class FieldFont extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    autobind(this);
    this.state = {
      loading: false,
      fonts: [],
    };
  }

  async componentDidMount() {
    try {
      const fonts = await this.props.google.fonts.list();
      this.setState({ fonts });
    }
    catch (e) {
      logger.captureException(e);
    }
  }

  onChange(family: string) {
    const font = this.state.fonts.find((f) => f.family === family);
    if (family && font) {
      let query = `${font.family}:`;
      const variantsLength = font.variants.length;
      font.variants.forEach((v, i) => {
        if (i + 1 === variantsLength)
          query += v;
        else
          query += v + ",";
      });
      this.props.onChange({
        family: font.family,
        category: font.category,
        query: query,
      });
    }
  }

  render() {
    const { value } = this.props;
    if (this.state.fonts.length === 0) return <p>Loading Fonts...</p>;
    return (
      <SelectAdv
        type="single"
        searchOnly={true}
        value={value}
        onChange={this.onChange}
        options={this.state.fonts}/>
    );
  }

}
